module.exports = __webpack_public_path__ + "img/indemnity-title.47814026.png";